const cleanText = (value) => {
  if (typeof value !== "string") return "";
  const text = value.trim().replace(/\s+/g, " ");
  return text === "[object Object]" ? "" : text;
};

export const normalizeUserId = (value) => {
  const candidate = typeof value === "object" && value !== null ? value.id : value;
  if (!["number", "string"].includes(typeof candidate)) return null;
  if (!/^\d+$/.test(String(candidate).trim())) return null;
  const id = Number(candidate);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export const getUserDisplayName = (user) => {
  if (!user || typeof user !== "object") {
    const id = normalizeUserId(user);
    return id ? `User #${id}` : "Unknown user";
  }

  const canonicalName = cleanText(user.name);
  if (canonicalName) return canonicalName;

  const firstName = cleanText(user.first_name) || cleanText(user.firstName);
  const lastName = cleanText(user.last_name) || cleanText(user.lastName);
  const combinedName = [firstName, lastName].filter(Boolean).join(" ");
  if (combinedName) return combinedName;

  const email = cleanText(user.email);
  if (email) return email;

  const id = normalizeUserId(user);
  return id ? `User #${id}` : "Unknown user";
};

export const normalizeProductionUserOptions = (payload) => {
  const users = Array.isArray(payload?.users) ? payload.users : [];
  const seen = new Set();

  return users.reduce((options, user) => {
    const id = normalizeUserId(user);
    if (!id || seen.has(id)) return options;
    seen.add(id);
    options.push({
      ...user,
      id,
      name: getUserDisplayName(user),
    });
    return options;
  }, []);
};

export const normalizeSelectedUserIds = (values) => {
  if (!Array.isArray(values)) return [];
  const seen = new Set();
  return values.reduce((ids, value) => {
    const id = normalizeUserId(value);
    if (!id || seen.has(id)) return ids;
    seen.add(id);
    ids.push(id);
    return ids;
  }, []);
};

export const findUserOption = (options, persistedValue) => {
  const list = Array.isArray(options) ? options : [];
  const id = normalizeUserId(persistedValue);
  if (id) return list.find((option) => normalizeUserId(option) === id) || null;

  const legacyName = cleanText(persistedValue);
  if (!legacyName) return null;
  return list.find((option) => getUserDisplayName(option) === legacyName) || null;
};

export const getSelectedUserOptions = (options, selectedIds) => {
  const ids = new Set(normalizeSelectedUserIds(selectedIds));
  return (Array.isArray(options) ? options : []).filter((option) =>
    ids.has(normalizeUserId(option))
  );
};

export const getDepartmentManagerDisplayName = (persistedValue, options) => {
  if (persistedValue == null || String(persistedValue).trim() === "") return "—";
  const option = findUserOption(options, persistedValue);
  if (option) return getUserDisplayName(option);

  const legacyName = cleanText(persistedValue);
  if (legacyName && !normalizeUserId(legacyName)) return legacyName;

  const id = normalizeUserId(persistedValue);
  return id ? `User #${id}` : "—";
};
